import { type ScrollbarsRef } from './types';

import { ModulesScrollbar } from './ModulesScrollbar';
import { ModulesScrollbarContext } from './ModulesScrollbarContext';
import { Scrollbar } from './Scrollbar';

export { Scrollbar, ModulesScrollbar, ModulesScrollbarContext };
export type ScrollbarPrimaryRef = ScrollbarsRef;
